import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ReportForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    details: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Email validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailPattern.test(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Phone number validation
    if (!/^\d{10}$/.test(formData.phone)) {
      alert("Phone number must be 10 digits.");
      return;
    }

    // Simulate successful form submission
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);
  };

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100">
      <div className="card p-4" style={{ maxWidth: '600px', width: '100%' }}>
        <h1 className="text-center mb-4">DhanShakti Request Form</h1>
        <form onSubmit={handleSubmit} id="request-form">
          <div className="form-group mb-3">
            <label htmlFor="name">Full Name <span className="required">*</span></label>
            <input 
              type="text" 
              className="form-control"
              id="name" 
              name="name" 
              value={formData.name}
              onChange={handleChange}
              required 
            />
          </div>
          
          <div className="form-group mb-3">
            <label htmlFor="email">Email <span className="required">*</span></label>
            <input 
              type="email" 
              className="form-control"
              id="email" 
              name="email" 
              value={formData.email}
              onChange={handleChange}
              required 
            />
          </div>
          
          <div className="form-group mb-3">
            <label htmlFor="phone">Phone Number (10 digits) <span className="required">*</span></label>
            <input 
              type="tel" 
              className="form-control"
              id="phone" 
              name="phone" 
              pattern="^\d{10}$" 
              value={formData.phone}
              onChange={handleChange}
              required 
            />
            <small className="form-text text-muted">Enter a 10-digit phone number</small>
          </div>
          
          <div className="form-group mb-4">
            <label htmlFor="details">Request Details </label>
            <textarea 
              className="form-control"
              id="details" 
              name="details"
              value={formData.details}
              onChange={handleChange}
              rows="5"
            ></textarea>
          </div>
          
          <button type="submit" className="btn btn-primary w-100">Submit Request</button>
        </form>

        {showSuccess && (
          <div id="success-message" className="alert alert-success mt-3">
            Your query has been submitted successfully!
          </div>
        )}

        <style jsx>{`
          /* Card styling for the form */
          .card {
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            box-sizing: border-box;
          }

          /* Header styling */
          h1 {
            color: #333;
            font-size: 24px;
          }

          /* Label styling */
          label {
            font-weight: bold;
            color: #333;
          }

          /* Styling for required field indicator */
          .required {
            color: red;
          }

          /* Responsive adjustments */
          @media (max-width: 768px) {
            h1 {
              font-size: 20px;
            }

            .card {
              padding: 15px;
              margin: 10px;
            }
          }

          @media (max-width: 480px) {
            h1 {
              font-size: 18px;
            }

            .card {
              padding: 10px;
              margin: 5px;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default ReportForm;